import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Color from 'color';

const deviceSizes = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  tablet: 768,
  laptop: 1024,
  laptopL: 1440,
  desktop: 2560,
};

const withTheme = (ComponentToWrap) => {
  const mapStateToProps = (state) => {
    const urlOrganisation = state.organisations?.urlOrganisation;
    return { organisation: state?.user?.organisation || urlOrganisation || null };
  };

  return connect(mapStateToProps)((props) => {
    const { innerWidth } = window;
    const [width, setInnerWidth] = useState(innerWidth);
    const [theme, setTheme] = useState({
      sizes: {
        isMobile: width < deviceSizes.tablet,
        isTablet: width >= deviceSizes.tablet && width < deviceSizes.laptop,
        isComputer: width >= deviceSizes.laptop,
      },
    });

    useEffect(() => {
      const updateDimensions = () => {
        const { innerWidth: currentInnerWidth } = window;
        setInnerWidth(currentInnerWidth);
      };

      window.addEventListener('resize', updateDimensions);

      return () => {
        window.removeEventListener('resize', updateDimensions);
      };
    }, []);

    useEffect(() => {
      const isMobile = width < deviceSizes.tablet;
      const isTablet = width >= deviceSizes.tablet && width < deviceSizes.laptop;
      const isComputer = width >= deviceSizes.laptop;
      const sizes = {
        isMobile,
        isTablet,
        isComputer,
        minStyle: Object.entries(deviceSizes).reduce((curr, [key, val]) => ({ ...curr, [key]: `min-width: ${val}px;` })),
        maxStyle: Object.entries(deviceSizes).reduce((curr, [key, val]) => ({ ...curr, [key]: `max-width: ${val}px;` })),
      };

      const organisation = props.organisation || {};
      const { primaryColour = '#14435B', secondaryColour = '#1b678e' } = organisation;
      const accent = Color(primaryColour).lighten(0.2);

      setTheme({
        primaryColour,
        secondaryColour: secondaryColour || primaryColour,
        accent: accent.hex(),
        secondaryAccent: secondaryColour ? Color(secondaryColour).lighten(0.6).fade(0.7).hex() : accent.hex(),
        shouldBeWhiteOnSecondary: Color(secondaryColour).isDark(),
        shouldBeWhiteOnPrimary: Color(primaryColour).isDark(),
        shouldBeWhiteOnAccent: accent.isDark(),
        boxShadow: '0.5px 0.5px 2.5px 1px #C0C0C0',
        sizes,
      });
    }, [props.organisation, width]);

    return (
      <ComponentToWrap {...props} theme={theme} />
    );
  });
};

export default withTheme;
